// @google/model-viewer 3.5.0, vendored at public/vendor/model-viewer.min.js.
// Injected on first open so the Job Summary does not download it otherwise.

const SRC = `${process.env.PUBLIC_URL || ''}/vendor/model-viewer.min.js`

let pending: Promise<void> | null = null

export const loadModelViewer = (): Promise<void> => {
  if (
    typeof customElements !== 'undefined' &&
    customElements.get('model-viewer')
  ) {
    return Promise.resolve()
  }
  if (!pending) {
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'module'
      script.src = SRC
      script.onload = () => {
        customElements.whenDefined('model-viewer').then(() => resolve())
      }
      script.onerror = () => {
        pending = null
        reject(new Error('model-viewer failed to load'))
      }
      document.head.appendChild(script)
    })
  }
  return pending
}
